/**
 * AuthResponse
 * @author Simpli CLI generator
 */
import {$, HttpBody, Model} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationMaxLength,
} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import RecoverPasswordRequest from '@/model/request/RecoverPasswordRequest'
import ResetPasswordRequest from '@/model/request/ResetPasswordRequest'
import AuthRequest from '@/model/request/AuthRequest'
import {Role} from '@/enums/Role'
import {sha256} from 'js-sha256'
import ChangeTemporaryPasswordRequest from '@/model/request/ChangeTemporaryPasswordRequest'
import ResponsavelUsuario from '@/model/resource/ResponsavelUsuario'
import * as Helper from '@/helpers'
import Administrador from '@/model/resource/Administrador'

const sha1 = require('sha1')

export default class AuthResponse extends Model {
  static async listResponsavelFilial(request: AuthRequest, spinner= 'getListaFiliaisResponsavel') {
    // @ts-ignore
    const fetch = async () => await new HttpBody<Responsavel[]>(Responsavel)
        .POST(`/user/auth/sign-in/responsavel`, request)
    return await $.await.run(fetch, spinner)
  }

  readonly $name: string = 'AuthResponse'

  @ValidationMaxLength(255)
  token: string | null = null

  role: Role | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(Responsavel)
  members: Responsavel[] = []

  regraExibicaoGrupoEconomico: boolean | null = null

  firstAccess: boolean | null = null

  usuario: ResponsavelUsuario | null = null

  administrador: Administrador | null = null

  async authenticate(spinner = 'authenticate', delay = 1000) {
    const fetch = async () => await this.GET(`/user/auth`)
    return await $.await.run(fetch, spinner, delay)
  }

  async changePassword(request: Responsavel, spinner = 'changePassword', delay = 1000) {
    const fetch = async () => {
      const model = new Responsavel()
      const isUser = Helper.getUsuarioNome() !== ''

      if (request.senhaAntiga && request.senhaAntiga.length) {
        model.senhaAntiga = isUser ? sha256(request.senhaAntiga) : sha1(request.senhaAntiga)
      }

      if (request.senha && request.senha.length) {
        model.senha = isUser ? sha256(request.senha) : sha1(request.senha)

        if (isUser) {
          const userDataString = localStorage.getItem('ud')

          if (userDataString) {
            const newUserData = {u: JSON.parse(userDataString).u, up: model.senha}
            localStorage.setItem('ud', JSON.stringify(newUserData))
          }
        }
      }

      if (request.senhaAdmin && request.senhaAdmin.length) {
        model.senhaAdmin = sha1(request.senhaAdmin)
      }

      if (request.senhaVisualizador && request.senhaVisualizador.length) {
        model.senhaVisualizador = sha1(request.senhaVisualizador)
      }

      if (request.senhaSac && request.senhaSac.length) {
        model.senhaSac = sha1(request.senhaSac)
      }

      if (request.senhaRastreamento && request.senhaRastreamento.length) {
          model.senhaRastreamento = sha1(request.senhaRastreamento)
      }

      const resp = await new HttpBody(String).POST(`/user/me/configuracao`, model)
      return resp.data as string
    }

    return await $.await.run(fetch, spinner)
  }

  async recoverPassword(request: RecoverPasswordRequest, spinner = 'recoverPassword', delay = 1000) {
    const model = new RecoverPasswordRequest()

    model.newPassword = sha1(request.newPassword || '')
    model.confirmPassword = sha1(request.confirmPassword || '')
    model.newPassword2 = sha256(request.newPassword || '')
    model.confirmPassword2 = sha256(request.confirmPassword || '')
    model.hash = request.hash

    const fetch = async () => {
      await request.validate()
      return await this.POST(`/user/auth/password/recover`, model)
    }

    return await $.await.run(fetch, spinner, delay)
  }

  async resetPassword(request: ResetPasswordRequest, spinner = 'resetPassword', delay = 1000) {
    const fetch = async () => {
      await request.validate()
      return await this.POST(`/user/auth/password/reset`, request)
    }

    return await $.await.run(fetch, spinner, delay)
  }

  async signIn(request: AuthRequest, spinner = 'signIn', delay = 1000) {
    const model = new AuthRequest()

    model.cnpj = request.cnpj

    const isEmail = model.cnpj && model.cnpj.includes('@')

    model.senha = isEmail ? sha256(request.senha || '') : sha1(request.senha || '')
    model.captchaResultCode = request.captchaResultCode

    const endpoint = isEmail ? `/user/auth/sign-in/step1` : `/user/auth/sign-in`

    const fetch = async () => {
      await model.validate()
      return await this.POST(endpoint, model)
    }

    return await $.await.run(fetch, spinner, delay)
  }

  async validateCode(request: AuthRequest, spinner = 'validateUserCode', delay = 1000) {
    const fetch = async () => {
      await request.validate()
      return await this.POST(`/user/auth/sign-in/step2`, request)
    }

    return await $.await.run(fetch, spinner, delay)
  }

  async sendCode(request: AuthRequest, spinner = 'sendCode', delay = 1000) {
    const fetch = async () => {
      await request.validate()
      return await this.POST(`/user/auth/sign-in/send-code`, request)
    }

    return await $.await.run(fetch, spinner, delay)
  }

  async validateFilial(request: AuthRequest, spinner = 'validateFilial', delay = 1000) {
    const fetch = async () => {
      await request.validate()
      return await this.POST(`/user/auth/sign-in/step3`, request)
    }

    return await $.await.run(fetch, spinner, delay)
  }

  async changeTemporaryPassword(
      request: ChangeTemporaryPasswordRequest,
      spinner = 'changeTemporaryPassword',
      delay = 1000,
  ) {
    await request.validate()
    const model = { ...request }
    model.user = request.user

    if (model.oldPassword && model.oldPassword.length) {
      model.oldPassword = sha256(model.oldPassword || '')
    }

    if (model.newPassword && model.newPassword.length) {
      model.newPassword = sha256(model.newPassword || '')
    }

    if (model.confirmPassword && model.confirmPassword.length) {
      model.confirmPassword = sha256(model.confirmPassword || '')
    }

    const fetch = async () => {
      return await this.POST('/user/auth/password/change-temporary', model)
    }

    return await $.await.run(fetch, spinner, delay)
  }

  async getTokenForAdmin(hash: string, spinner= 'getTokenForAdmin') {
    const fetch = async () => {
      return this.POST('/user/auth/sign-in/admin', hash)
    }

    return await $.await.run(fetch, spinner)
  }
}
